<template>
    <v-dialog v-model="viewPeriodModal" max-width="400px">
        <v-card>
            <v-card-title>
                <span>{{ $page.props.lang.edit_period ||'Edit Period'}}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="viewPeriodModal = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                    <v-row>
                        <v-col cols="12" class="mt-4">
                            <label class="custom-label">{{ $page.props.lang.startDate ||'Start date'}}</label>  
                                <v-menu
                                    class="fit"
                                    v-model="startDatePicked"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="updatePeriod.start_date | formatDate" 
                                            append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" 
                                            @click:append="startDatePicked = true" outlined dense
                                            :error-messages="responseErrors.start_date"
                                            @focus="responseErrors.start_date=''"
                                            :hide-details="!responseErrors.start_date"></v-text-field>
                                    </template>
                                    <v-date-picker 
                                        @input="startDatePicked = false"
                                        :max="updatePeriod.end_date"
                                        locale="sr-latn"
                                        v-model="updatePeriod.start_date" 
                                        :first-day-of-week="1" no-title scrollable color="primary">
                                    </v-date-picker>
                                </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <label class="custom-label">{{ $page.props.lang.endDate || "End date"}}</label>
                                <v-menu
                                    class="fit"
                                    v-model="endDatePicked"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="updatePeriod.end_date | formatDate" 
                                            append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" 
                                            @click:append="endDatePicked = true" outlined dense
                                            :error-messages="responseErrors.end_date"
                                            @focus="responseErrors.end_date=''"
                                            :hide-details="!responseErrors.end_date"></v-text-field>
                                    </template>
                                    <v-date-picker 
                                        @input="endDatePicked = false"
                                        :min="updatePeriod.start_date"
                                        locale="sr-latn"
                                        v-model="updatePeriod.end_date" 
                                        :first-day-of-week="1" no-title scrollable color="primary">
                                    </v-date-picker>
                                </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <v-switch v-model="updatePeriod.limited_visits" :label="$page.props.lang.limitSessions || 'Limit Sessions'"></v-switch>
                                <label v-if="updatePeriod.limited_visits" class="custom-label">{{ $page.props.lang.limit || 'Total Sessions' }}</label>
                                <v-text-field v-if="updatePeriod.limited_visits" 
                                    v-model="updatePeriod.total_visits" type="number" 
                                    outlined dense solo flat
                                    :error-messages="responseErrors.total_visits"
                                    @focus="responseErrors.total_visits=''"
                                    :hide-details="!responseErrors.total_visits"></v-text-field>
                        </v-col>
                    </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="regular" @click="viewPeriodModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                <v-btn color="primary" :loading="updatingPeriod" @click="update()">{{ $page.props.lang.save || "Save" }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import EventBus from '@/js/eventbus'

export default {

    props: {
        open: Boolean,
        period: Object,
    },
    data(){
        return {
            startDatePicked: false,
            endDatePicked: false,
            responseErrors: [],
            updatePeriod: Object.assign({}, this.period),
            updatingPeriod: false
        };
    },
    computed: {
        viewPeriodModal: {
            get: function() {
                return this.open
            },
            set: function(newValue) {
                EventBus.$emit('CLOSE_UPDATE_PERIOD_MODAL');
                return newValue;
            }
        }
    },
    methods: {

        update(){

            this.updatingPeriod = true;

            axios.post('/backoffice/members/updatePeriod', this.updatePeriod)
            .then((r) => {
                this.updatingPeriod = false;
                let color = 'success';
                if(r.data.status != "OK"){
                    color = 'error';
                }else{
                    EventBus.$emit('CLOSE_UPDATE_PERIOD_MODAL', {
                    reload: true
                });
                }

                EventBus.$emit('SHOW_NOTIFICATION', {
                    message: r.data.message,
                    color: color,        
                    timeout: 5000
                });
                
            })
             .catch(error => {
                     this.updatingPeriod = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });;
        }
    }
}

</script>